import { BRAND_COLORS } from "../../lib/bookingStatus";
const emptyContact = { label: "", name: "", phone: "", note: "" };
let __uid = 0;
const _uid = () => `row-${Date.now()}-${++__uid}`;

export function EmergencyContactsSection({ de, editing, form, setForm, selected }) {
  const items = form?.emergency_contacts || [];

  const update = (i, patch) => {
    const list = [...items];
    list[i] = { ...list[i], ...patch };
    setForm({ ...form, emergency_contacts: list });
  };
  const remove = (i) => setForm({ ...form, emergency_contacts: items.filter((_, idx) => idx !== i) });
  const add = () => setForm({ ...form, emergency_contacts: [...items, { ...emptyContact, _uid: _uid() }] });

  return (
    <section className="bg-navy text-ivory p-6 md:p-8 lg:col-span-2" style={{ background: BRAND_COLORS.navy }} data-testid="handbook-emergency">
      <div className="label-caps mb-4" style={{ color: BRAND_COLORS.gold }}>
        {de ? "Notfallkontakte" : "Emergency contacts"}
      </div>
      {editing ? (
        <div className="space-y-3">
          {items.map((c, i) => (
            <div key={c._uid || i} className="grid grid-cols-1 md:grid-cols-12 gap-2" data-testid={`emergency-row-${i}`}>
              <input placeholder={de ? "Bezeichnung" : "Label"} value={c.label}
                onChange={(e) => update(i, { label: e.target.value })}
                className="md:col-span-3 bg-navy-dark text-ivory border border-ivory/20 focus:border-gold focus:outline-none px-3 py-2 text-[13px]"
                style={{ background: BRAND_COLORS.navyDark }} />
              <input placeholder={de ? "Name" : "Name"} value={c.name || ""}
                onChange={(e) => update(i, { name: e.target.value })}
                className="md:col-span-3 bg-navy-dark text-ivory border border-ivory/20 focus:border-gold focus:outline-none px-3 py-2 text-[13px]"
                style={{ background: BRAND_COLORS.navyDark }} />
              <input placeholder={de ? "Telefon" : "Phone"} value={c.phone}
                onChange={(e) => update(i, { phone: e.target.value })}
                className="md:col-span-3 bg-navy-dark text-ivory border border-ivory/20 focus:border-gold focus:outline-none px-3 py-2 text-[13px]"
                style={{ background: BRAND_COLORS.navyDark }} />
              <input placeholder={de ? "Notiz" : "Note"} value={c.note || ""}
                onChange={(e) => update(i, { note: e.target.value })}
                className="md:col-span-2 bg-navy-dark text-ivory border border-ivory/20 focus:border-gold focus:outline-none px-3 py-2 text-[13px]"
                style={{ background: BRAND_COLORS.navyDark }} />
              <button type="button" onClick={() => remove(i)}
                className="md:col-span-1 border border-gold/40 text-gold text-[11px] tracking-widest uppercase hover:bg-gold hover:text-navy transition-colors">
                ×
              </button>
            </div>
          ))}
          <button type="button" data-testid="handbook-add-contact-btn" onClick={add}
            className="border border-gold text-gold px-4 py-2 text-[12px] tracking-widest uppercase hover:bg-gold hover:text-navy transition-colors">
            + {de ? "Kontakt hinzufügen" : "Add contact"}
          </button>
        </div>
      ) : (selected.emergency_contacts || []).length === 0 ? (
        <div className="text-[13px] text-ivory/60">—</div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-4">
          {(selected.emergency_contacts || []).map((c, i) => (
            <div key={i} className="flex items-start gap-4 pb-3 border-b border-ivory/10 last:border-b-0" data-testid={`emergency-contact-${i}`}>
              <span className="font-display text-gold text-2xl leading-none w-6 shrink-0">
                {String(i + 1).padStart(2, "0")}
              </span>
              <div className="flex-1 min-w-0">
                <div className="text-[11px] tracking-widest uppercase text-ivory/60">{c.label}</div>
                {c.name && <div className="text-[14px] text-ivory">{c.name}</div>}
                <a href={`tel:${c.phone}`} className="font-display text-xl text-ivory hover:text-gold transition-colors">{c.phone}</a>
                {c.note && <div className="text-[11px] text-ivory/60 italic mt-1">{c.note}</div>}
              </div>
            </div>
          ))}
        </div>
      )}
    </section>
  );
}
